import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
declare var jQuery:any;



@Component({
  selector: 'iboxtools',
  templateUrl: 'iboxtools.template.html'
})



export class IboxtoolsComponent implements OnInit, OnChanges  {
 
 
   @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent : Observable<any[]>;

  @Input() div_id?; // impliments on changes.
  @Input() state?; // just hide the div oin the compoent with css

 
 
  ngOnChanges(changes: SimpleChanges): void {
    
   
    
  }
  ngOnInit(): void {
    
    
  }




  // public collapse(e):void {
  //   e.preventDefault();
  //   let ibox = jQuery(e.target).closest('div.ibox');
  //   let button = jQuery(e.target).closest('i');
  //   let content = ibox.children('.ibox-content');
  //   content.slideToggle(200);
  //   button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
  //   ibox.toggleClass('').toggleClass('border-bottom');
  //   setTimeout(function () {
  //     ibox.resize();
  //     ibox.find('[id^=map-]').resize();
  //   }, 50);

  // }

  // public close(e):void {
  //   e.preventDefault();
  //   let content = jQuery(e.target).closest('div.ibox');
  //   content.remove();
  // }






  public collapse(e, div_id):void {

    if (this.div_id == "" || this.div_id == null){
      this.div_id = 'ibox';
    }

    e.preventDefault();
    let ibox = jQuery(e.target).closest('div.' + this.div_id);
    let button = jQuery(e.target).closest('i');
    let content = ibox.children('.ibox-content');
    content.slideToggle(200);
    button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    ibox.toggleClass('').toggleClass('border-bottom');
    setTimeout(function () {
      ibox.resize();
      ibox.find('[id^=map-]').resize();
    }, 50);

  }

  public close(e, div_id):void {
    if (this.div_id == "" || this.div_id == null){
      this.div_id = 'ibox';
    }
    e.preventDefault();
    let content = jQuery(e.target).closest('div.'+ this.div_id);
    content.remove();
  }



}
